import { GradeProgress } from '../../auth'
import { UserId } from '../users'
import { Point } from '../points'
import { Grade } from '../grades'
import { RankingPrevMonthComparison } from '../rankings'

export enum GradeForecastType {
  UP = 'forecast_up',
  KEEP = 'forecast_keep',
  DOWN = 'forecast_down',
}

export enum GradeHistoryType {
  GRADE_UP = 'history_grade_up',
  GRADE_KEEP = 'history_grade_keep',
  GRADE_DOWN = 'history_grade_down',
}

export enum GradeNotificationType {
  GRADE_UP = 'notification_grade_up',
  GRADE_DOWN = 'notification_grade_down',
  ACHIEVEMENT = 'notification_achievement',
  WELCOME_BACK = 'notification_welcome_back',
}

export interface GradeNotification {
  id: string // UUID
  userId: UserId
  type: GradeNotificationType
  beforeGrade: Grade
  afterGrade: Grade
  content: string
  isRead: boolean
}

export interface GradeHistory {
  type: GradeHistoryType
  userId: UserId
  targetMonth: string
  beforeGrade: Grade
  afterGrade: Grade
  datetime: string
}

export interface MeResponse {
  userId: UserId
  nickname: string
  imagePath: string | null
  enthusiasmComment: string | null
  latestRank: number | null
  latestRankingTargetMonth: string | null
  latestUseAmount: number | null
  latestRankMonthOverMonth: RankingPrevMonthComparison
  grade: Grade
  progress: GradeProgress
  pointReturnRate: number
  reservationLimit: number
  pointsToExpire: Point[]
  isExemptedFromDowngrade: boolean
  monthlyReferralTicketIssuanceLimit: number
  monthlyReferralTicketRewardToSubject: number
  corporation: null | {
    name: string
  }
  isCorporateMember: boolean
  isKarteRegistered: boolean
}

export interface MeUpdateParams {
  nickname?: string
  enthusiasmComment?: string
  image?: File
  deleteImage?: boolean
}

export type MeGradeNotificationsResponse = GradeNotification | []
export type MeGradeHistoriesResponse = GradeHistory[]
